import {
  Button,
  Col,
  DatePicker,
  Form, Input,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import React from "react";

const { Option } = Select;
const { Text } = Typography;

function FeedbackEdit(props) {
  const { isOpen, toggle, initialValues, onSubmit, status } = props;
  const dateFormat = "Do MMMM YYYY h:mm:ssA Z";

  return (
    <Modal
      title="Edit Feedback"
      visible={isOpen}
      onCancel={() => toggle()}
      footer={null}
    >
      {status.type === "LOADING" ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          <Form.Item
            label="Status"
            name="isOpen"
            rules={[
              { required: true, message: "Please input is open status!" },
            ]}
          >
            <Select>
              <Option value={true}>Open</Option>
              <Option value={false}>Close</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Start Date (Local)"
            name="startDate"
            rules={[{ required: true, message: "Please input start date!" }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              format={dateFormat}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label="End Date (Local)"
            name="endDate"
            rules={[{ required: true, message: "Please input end date!" }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              format={dateFormat}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Title" name="title">
            <Input />
          </Form.Item>
          <Form.Item label="For trainer?" name="forTrainer">
            <Select>
              <Select.Option value={true}>True</Select.Option>
              <Select.Option value={false}>False</Select.Option>
            </Select>
          </Form.Item>
          {status.type === "ERROR" ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === "SUCCESS" ? (
            <Text type="success">{status.message}</Text>
          ) : null}
          <Row justify="end" gutter={12}>
            <Col>
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default FeedbackEdit;
